<div class="toast-wrapper {{toastStyle()}}" [@openClose]="isOpen ? 'open' : 'closed'">
  <div *ngIf="hasIcon()" class="toast-icon-wrapper"><span class="ui-messages-icon pi {{iconRef()}} {{iconStyle()}}"></span></div>
  <div class="toast-message-content"><span class="toast-message-content-span" [innerHtml]="toastMsg.messageHtml"></span></div>
  <i class="pi pi-times close-icon" (click)="close()"></i>
</div>
